import { render, staticRenderFns } from "./DialogTutorial.vue?vue&type=template&id=6cabc2df&"
import script from "./DialogTutorial.vue?vue&type=script&lang=js&"
export * from "./DialogTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports